import React from "react";
import classNames from "classnames";

import {PanelExpandable} from "@pg-design/expandable-module";
import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {FOOTER_TEST_IDS} from "@pg-mono/test-ids";

import * as styles from "./FooterPanelExpandable.module.css";

export interface IProps {
    children: React.ReactNode;
    title: string;
    alwaysOpen?: boolean;
    className?: string;
}

export const FooterPanelExpandable: React.FC<IProps> = (props) => {
    return (
        <PanelExpandable
            className={classNames(styles.panel, props.className)}
            alwaysOpen={props.alwaysOpen}
            title={
                <Text variant="headline_6" as="h4" dataTestId={FOOTER_TEST_IDS.PANEL_EXPANDABLE}>
                    {props.title}
                </Text>
            }
            panelArrowIcon={<ChevronDownIcon size="2.2" fill="#fff" />}
        >
            {props.children}
        </PanelExpandable>
    );
};
import React from "react";
import classNames from "classnames";

import {PanelExpandable} from "@pg-design/expandable-module";
import {ChevronDownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {FOOTER_TEST_IDS} from "@pg-mono/test-ids";

import * as styles from "./FooterPanelExpandable.module.css";

export interface IProps {
    children: React.ReactNode;
    title: string;
    alwaysOpen?: boolean;
    className?: string;
}

export const FooterPanelExpandable: React.FC<IProps> = (props) => {
    return (
        <PanelExpandable
            className={classNames(styles.panel, props.className)}
            alwaysOpen={props.alwaysOpen}
            title={
                <Text variant="headline_6" as="h4" dataTestId={FOOTER_TEST_IDS.PANEL_EXPANDABLE}>
                    {props.title}
                </Text>
            }
            panelArrowIcon={<ChevronDownIcon size="2.2" fill="#fff" />}
        >
            {props.children}
        </PanelExpandable>
    );
};
